<div class="relative">
  <button
    class="flex gap-2 h-11 align-middle justify-center text-sm text-secondary dark:text-dark-muted px-3 py-3 border-gray-200 dark:border-dark-border hover:bg-gray-50 dark:hover:bg-dark-hover hover:text-primary dark:hover:text-gray-200"
    [ngClass]="[right ? 'border-r' : 'border-l']"
    (click)="toggle()"
  >
    <ng-content></ng-content>
  </button>

  @if (dropDownOpen) {
    <div
      class="absolute top-11 z-30 min-w-52 w-auto bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border shadow-md text-sm"
      [ngClass]="right ? 'left-0' : 'right-0'"
    >
      @if (directContent) {
        <div class="px-3 py-2">
          <ng-content select="[content]"></ng-content>
        </div>
      } @else {
        @if (collection.length === 0) {
          <div class="px-3 py-2 text-secondary dark:text-dark-muted flex gap-2 items-center">
          <span class="text-theme-primary">
            <lucide-angular size="16" [name]="AlertCircle"></lucide-angular>
          </span>
            {{ 'dropDown.noResults' | translate }}
          </div>
        } @else {
          @for (item of collection; track item.id; let i = $index) {
            <a
              href="#"
              class="px-3 py-2 flex gap-2 items-center border-l-4 hover:bg-gray-50 dark:hover:bg-dark-hover hover:border-gray-200 dark:hover:border-dark-border"
              [ngClass]="[((selectable === 'single' && this.value === item.id) || (selectable === 'multiple' && this.value?.includes(item.id))) ? 'border-theme-primary text-primary font-semibold' : 'border-transparent text-secondary']"
              (click)="$event.preventDefault(); selectItem(item)"
            >
              @if (item.icon) {
                <span class="text-theme-primary">
                <lucide-angular size="16" [name]="item.icon"></lucide-angular>
              </span>
              }
              {{ item.title | translate }}
            </a>
          }
        }
      }
    </div>
  }
</div>
